export default __webpack_public_path__ + "static/download-7879-5bd2779426d42e1a3393c57796ddb709.jpg";